module.exports = __webpack_public_path__ + "static/media/3 wolf warrior sleeve viking fenrir tattoo .1280x960.d26568bc.webp";